import React from 'react';
import PropTypes from 'prop-types';

import { black, white, grayDarker } from '@bufferapp/ui/style/colors';
import { getColorContrast } from '~/shared-components/ColorPicker/utils/HexValidations';
import { ChartLine } from '@bufferapp/ui/Icon';

import { ParagraphText } from '../styles';
import { CampaignWrapper } from './style';

const CampaignBanner = ({ campaign }) => {
  const ColorContrastIsBlack = campaign?.color?.value
    ? getColorContrast(campaign?.color?.value) === black
    : null;

  return (
    <CampaignWrapper campaignColor={campaign?.color?.value}>
      <ChartLine color={ColorContrastIsBlack ? grayDarker : white} />
      <ParagraphText
        type="p"
        color={ColorContrastIsBlack ? 'grayDarker' : 'white'}
      >
        {campaign.name}
      </ParagraphText>
    </CampaignWrapper>
  );
};

CampaignBanner.propTypes = {
  campaign: PropTypes.shape({
    color: PropTypes.shape({
      value: PropTypes.string,
    }),
    name: PropTypes.string,
  }),
};

CampaignBanner.defaultProps = {
  campaign: {},
};

export default CampaignBanner;
